import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Image from "next/image";
import {Typography} from "@mui/material";
import React from "react";
import {useTheme} from "@mui/material/styles";
import {SoftwareFeatureCardProps} from "@/types/software";

export default function SoftwareFeatureCard({image, title, description}: SoftwareFeatureCardProps) {
    const theme = useTheme()

    return (
        <Card
            sx = {{
            textAlign: 'center',
            border: 1,
            borderColor: theme.palette.grey[500],
            overflow: 'visible',
            alignItems: "center",
            mt: 4,
        }}
        >
            <Box sx = {{mt: -10}} >
                <Image height = {200} style = {{aspectRatio: 1}} src = {image} alt = {title} />
            </Box >

            <Box px={4} minHeight = {140} >
                <Typography fontWeight={500} variant = 'h6' mb={1}>
                    {title}
                </Typography >
                <Typography sx = {{color: theme.palette.grey[700]}} >
                    {description}
                </Typography >
            </Box >
        </Card >
    )
}